export default __webpack_public_path__ + "static/media/bg-home.b5b33864.jpg";